import { AlertCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';

/**
 * Shared empty-state copy for detail-page cards whose backend endpoint
 * does not exist yet. Surfaced when the consuming hook lifts
 * `NotImplementedError` into `isError`, so operators see "no data" rather
 * than infinite skeletons or fabricated numbers.
 */
export function ExperimentDataUnavailable({ label }: { label?: string }) {
  const { t } = useTranslation('experiments');
  return (
    <div
      role="status"
      aria-live="polite"
      className="text-muted-foreground flex items-center gap-2 py-6 text-sm"
    >
      <AlertCircle className="h-4 w-4" aria-hidden="true" />
      <span>{label ?? t('detail.dataUnavailable')}</span>
    </div>
  );
}
